import classnames from 'classnames';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import PhoneNumber from '../../common/phoneNumber';
import SanitizedLink from '../../common/sanitizedLink';

class ContactRow extends React.Component {
    _debounce = null;

    state = {
        expanded: false,
        shouldExpand: false
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash || this.state.expanded !== nextState.expanded || this.state.shouldExpand !== nextState.shouldExpand;
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated)
            this.setState({ expanded: true });

        if (this.props.isHideAllActivated !== prevProps.isHideAllActivated)
            this.setState({ expanded: false });

        if ((prevProps.data === null || prevProps.data === undefined) && (this.props.data !== null && this.props.data !== undefined)) {
            this._debounce = window.setTimeout(() => this.updateSize(), 250);
        }
    }

    componentDidMount() {
        this.test = window.addEventListener('resize', this.onResize, false)
        this.updateSize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false)
    }

    updateSize = () => {
        this._debounce = undefined;
        if (this.dataRef === null || this.dataRef === undefined) {
            return;
        }
        const shouldExpand = this.dataRef.offsetWidth < this.dataRef.scrollWidth;
        if (this.state.shouldExpand !== shouldExpand && !this.state.expanded) {
            this.setState({ shouldExpand });
        }
    }

    onResize = e => {
        if (this._debounce !== null && this._debounce !== undefined) {
            window.clearTimeout(this._debounce);
        }
        this._debounce = window.setTimeout(() => this.updateSize(), 250);
    }

    render() {
        return this.renderContact(this.props.data, this.props.links);
    }

    renderContact = (data, links) => {
        if (data === undefined || data === null || !data.items || data.items.length < 1)
            return null;

        const items = data.items.map((i, iter) => {
            switch (links) {
                case 'web': return this.createLink(i.value, iter)
                case 'phone': return <PhoneNumber key={iter} label={i.value} />
                default: return <span key={iter}>{i.value}</span>
            }
        });

        return (
            <div className='ident-item' key={data.id}>
                <span className="bold">{data.name}</span>
                <span className={classnames({ 'text-shorten': !this.state.expanded })}>
                    <p ref={el => this.dataRef = el}>{this.renderItems(items)}</p>
                    {!this.state.expanded && this.state.shouldExpand && <span className="link-functional" onClick={this.showLess}><Translate id="Report.Common.More" /></span>}
                    {this.state.expanded && <span className="link-functional" onClick={this.showLess}><Translate id="Report.Common.Less" /></span>}
                </span>
            </div>
        )
    }

    renderItems = (items, renderExternalLinks = false) => {
        return items.map((x, i) => (i + 1) < items.length
            ? <React.Fragment key={i}>{this.renderItem(x, renderExternalLinks, i)}{"; "}</React.Fragment>
            : this.renderItem(x, renderExternalLinks, i))
    }

    renderItem = (item, isExternalLink, key) => {
        return isExternalLink ? <span key={key} className="link-external">{item}</span> : <React.Fragment key={key}>{item}</React.Fragment>
    }

    showLess = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    createLink = (val, iter) => {
        let href = val;
        if (!val.startsWith("http") && !val.startsWith("www."))
            href = `http://www.${val}`;
        else if (val.match("www."))
            href = `http://${val}`;

        return <SanitizedLink key={iter} link={href} label={val} empty={<span>{val}</span>} />;
    }
}

export default connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(ContactRow);